import { useState } from "react";
import { FooterForm, FeaturedSectors, StartupGaining, TestimonialCarousel, Banner, Presenters } from "../components/index";
import { tracking } from '../utils/tracking';
import { imgs } from '../assets/imgs';
import { useResizeImg } from '../hooks/useResizeImg';

export const Startups = () => {
   document.title = "New York Venture Summit | Startups";
   const [isLoading, setIsLoading] = useState(true);
   const imageSource = useResizeImg(imgs.startups.startupBannerDesktop, imgs.startups.startupBannerMobile)

   return (
      <div className='startups'>
         <Banner imageSource={imageSource} isLoading={isLoading} setIsLoading={setIsLoading} >
            <section >
               <h1>Featured Companies</h1>
               <h1>Get Noticed. Get Funded. Grow Faster</h1>
            </section>
            {/* <section>
               <a className="btn b2" href='https://account.youngstartup.com' onClick={() => { tracking(283); }}>APPLY NOW</a>
            </section> */}
         </Banner>
         <FeaturedSectors />
         <StartupGaining />
         <TestimonialCarousel pageName={"startups;"} />
         {/* <Presenters /> */}
         <FooterForm />
      </div >
   );
};
